<div class="ui-pagination">
  <span class="ui-pagination__info">Page {{ currentPage }} of {{ totalPages }}</span>
  <div class="ui-pagination__controls">
    <button
      class="ui-pagination__btn"
      type="button"
      [disabled]="!canGoPrev"
      (click)="onPrev()">
      Previous
    </button>
    <button
      class="ui-pagination__btn"
      type="button"
      [disabled]="!canGoNext"
      (click)="onNext()">
      Next
    </button>
  </div>
</div>
